import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import { Translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import VirtualFenceAlertMap from './VirtualFenceAlertMap';

export const VirtualFenceAlert = (props: RouteComponentProps<{ id: string }>) => {
  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center">
        <h4 id="fleetSenseApp.virtualFenceCircle.home.createOrEditLabel" data-cy="VirtualFenceCircleCreateUpdateHeading">
        <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.detail.title">VirtualFenceCircleAlert</Translate>
        </h4>
        <Row>
          <Button outline size="sm" replace color="info" data-cy="entityDetailsBackButton" onClick={() => props.history.goBack()}>
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
        </Row>
      </div>
      <Row className="mt-2">
        <Col className="p-0">
          <VirtualFenceAlertMap props={props} />
        </Col>
      </Row>
    </Fragment>
  );
};
